import { Form } from "antd";

/**
 * @param {FormInstance} form -
 */
export const resetJobPostingForm = (form) => {
  const defaultValues = {
    postingJobTitle: "",
    budgetApproved: "",
    jobStatus: "",
    managerId: "",
    department: "",
    employmentType: "",
    maximumExperience: "",
    compensation: "",
    jobLocationType: "",
    jobType: "",
    jobInternalCode: "",
    Skills: [],
  };
  form.setFieldsValue(defaultValues);
};

/**
 * @param {FormInstance} form
 */
export const resetForm = (form) => {
  form.resetFields();
};
